<script>
    import { Bar } from 'vue-chartjs'

    export default {
        extends: Bar,
        props: ['chartData'],
        watch: {
            chartData () {
                this.renderChart(this.chartData, { onClick: this.onClickHandle })
            },
            deep: true
        },
        mounted () {
            this.renderChart(this.chartData, { onClick: this.onClickHandle })
        },
        methods: {
            onClickHandle (point, event) {
                const item = event[0]
                this.$emit('on-click-in-graph-element',
                           item._model.label
                )
            }
        }
    }
</script>
